"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swing = void 0; // -------------------------------------------
//   ANIMATIONS > SWING
// -------------------------------------------
// (((((((((( ~~~~~~~~~~ SWING ~~~~~~~~~~ )))))))))) //

var swing = {
  // ***** SWING ***** //
  '@keyframes swing': {
    '20%': {
      transform: 'rotate3d(0, 0, 1, 15deg)'
    },
    '40%': {
      transform: 'rotate3d(0, 0, 1, -10deg)'
    },
    '60%': {
      transform: 'rotate3d(0, 0, 1, 5deg)'
    },
    '80%': {
      transform: 'rotate3d(0, 0, 1, -5deg)'
    },
    to: {
      transform: 'rotate3d(0, 0, 1, 0deg)'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.swing = swing;